module.exports = __webpack_public_path__ + "fonts/montserrat-lightitalic-webfont.713c1a4.woff2";